import PERMISOS from "#constants/perfiles"
import { UseHasPermission } from "#hooks/useHasPermission"
import { STATUS } from "#performance-evaluation/constants"
import HowToRegIcon from "@mui/icons-material/HowToReg"
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck"
import { Button, Stack } from "@mui/material"
import { Fragment, useState } from "react"
import { ActionPlanFormDialog } from "../action-plan/ActionPlanForm"
import MyEvaluationsFinished from "./MyEvaluationsFinished"
import { useColaboradorId } from "app/userSlice"
import MyEvaluationsDetails from "./MyEvaluationsDetails"

export function MyEvaluationsCardButtons({ evaluation, jefe_directo }) {
	const [open, setOpen] = useState(false)
	const [openFinish, setOpenFinish] = useState(false)
	const [openDetails, setOpenDetails] = useState(false)
	const colaboradorId = useColaboradorId()
	const isRh = UseHasPermission(PERMISOS.RH)
	const isBossDirect = jefe_directo === colaboradorId || isRh
	const showButtonPlan = evaluation.status === STATUS.BOSS_EVALUATION && isBossDirect

	if (!evaluation.is_active) return <ButtonDetails evaluation={evaluation} />

	return (
		<Fragment>
			<Stack spacing={2} direction="row" sx={{ mt: 2 }}>
				<ButtonDetails evaluation={evaluation} />
				<MyEvaluationsCardButton
					label="Crear Plan de Acción"
					onClick={() => setOpen(true)}
					hidden={!showButtonPlan}
					icon={<PlaylistAddCheckIcon />}
				/>
				<MyEvaluationsCardButton
					label="Finalizar Evaluación"
					onClick={() => setOpenFinish(true)}
					hidden={!isRh}
					icon={<HowToRegIcon />}
				/>
			</Stack>
			<ActionPlanFormDialog
				{...{
					open,
					setOpen,
					evaluationId: evaluation.id,
					perfilPuesto: evaluation.perfil_puesto,
				}}
			/>
			<MyEvaluationsFinished
				{...{ open: openFinish, setOpen: setOpenFinish, evaluationId: evaluation.id }}
			/>
			<MyEvaluationsDetails
				open={openDetails}
				setOpen={setOpenDetails}
				evaluationId={evaluation.id}
			/>
		</Fragment>
	)
}

const MyEvaluationsCardButton = ({ label, onClick, hidden, icon }) => {
	if (hidden) return null
	return (
		<Button
			onClick={onClick}
			variant="contained"
			startIcon={icon}
			sx={{
				bgColor: "white",
				// color: "#667eea",
				fontWeight: 600,
				"&:hover": {
					bgColor: "rgba(255, 255, 255, 0.9)",
					transform: "scale(1.05)",
				},
			}}
		>
			{label}
		</Button>
	)
}

const ButtonDetails = ({ evaluation }) => {
	const [openDetails, setOpenDetails] = useState(false)
	for (let evaluator of evaluation.evaluations_evaluators) {
		if (evaluator?.score_competencies)
			return (
				<Fragment>
					<MyEvaluationsCardButton
						label="detalles"
						onClick={() => setOpenDetails(true)}
						hidden={evaluation.status === STATUS.SOLICITADA}
						icon={<HowToRegIcon />}
					/>
					<MyEvaluationsDetails
						open={openDetails}
						setOpen={setOpenDetails}
						evaluationId={evaluation.id}
					/>
				</Fragment>
			)
	}

	return null
}
